export default {"src":"/pro/_next/static/media/tao.7662a9f4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};